(function($) {

    //---------------------
    // Set variables for this document
    //---------------------
    var menuOpened = false;
    var navHeight = $(".navigation-wrapper").outerHeight();
    var navTopHeight = $('.navigation__top').is(':visible') ? $('.navigation__top').outerHeight(true) : 0;
    var infoHeight = 0;
    var fullHeight = navHeight + navTopHeight;
    if ($(".info-bar").length) {
        infoHeight = $(".info-bar").height();
        fullHeight = fullHeight + infoHeight;
    }



    //---------------------
    // Set variables for css on load and resize
    //---------------------
    document.documentElement.style.setProperty('--info-height', `${infoHeight ? infoHeight : 0}px`);
    document.documentElement.style.setProperty('--menu-full-height', `${fullHeight}px`);
    document.documentElement.style.setProperty('--menu-top-height', `${navTopHeight}px`);
    var w = $(window).width();
    window.addEventListener('resize', () => {
        if ($(window).width() == w) return;
        w = $(window).width();
        navHeight = $(".navigation-wrapper").outerHeight();
        navTopHeight = $('.navigation__top').is(':visible') ? $('.navigation__top').outerHeight(true) : 0;
        fullHeight = navHeight + navTopHeight;
        infoHeight = 0;
        if ($(".info-bar").length) {
            infoHeight = $(".info-bar").height();
            fullHeight = fullHeight + infoHeight;
        }
        document.documentElement.style.setProperty('--info-height', `${infoHeight ? infoHeight : 0}px`);
        document.documentElement.style.setProperty('--menu-full-height', `${fullHeight}px`);
        document.documentElement.style.setProperty('--menu-top-height', `${navTopHeight}px`);
    });



    //---------------------
    // Toggle menu on hamburger click
    //---------------------
    $(".navigation__hamburger").not('.navigation__search-close').on("click", function () {
        $(".navigation").toggleClass("opened");
        menuOpened = !menuOpened;
        if(menuOpened){
            $(".navigation__menu").addClass("navigation__menu--active");
            $('html').addClass('overflow_hidden');
            if (infoHeight > 0 && $(document).scrollTop() <= infoHeight) {
                var $infoHeightActual = infoHeight - $(window).scrollTop();
                $(".navigation.opened").css("top", $infoHeightActual);
            }
        } else {
            $(".navigation__menu").removeClass("navigation__menu--active");
            $('html').removeClass('overflow_hidden');
            if (infoHeight > 0 && $(document).scrollTop() <= infoHeight) {
                $(".navigation").css("top", '');
            }
        }
        $(".navigation__hamburger-icon").toggleClass("navigation__hamburger-icon--opened");
    })


    //---------------------
    // Open menu on click or hover
    //---------------------
    $(".navigation__items-has-submenu").each(function(){
        let $submenuHeight = $(this).children(".navigation__submenu").outerHeight();
        $(this).children(".navigation__submenu").css('max-height', '0');
        $(this).on("click", function (e) {
            e.stopPropagation();
            if ($(this).hasClass('navigation__item--opened')){
                $(this).children(".navigation__submenu").removeClass("navigation__submenu--opened").css('max-height', '0');
                $(this).removeClass("navigation__item--opened");
            } else {
                $(this).children(".navigation__submenu").addClass("navigation__submenu--opened").css('max-height', $submenuHeight+'px');
                $(this).addClass("navigation__item--opened");
            }
        })
    });


    //---------------------
    // Add white background and overlay when hover to navigation
    //---------------------
    $('.navigation').on("mouseenter", function (e) {
        $('.navigation-header').addClass('navigation-hover navigation-hover-trans');
    })
    $('.navigation__menu').on("mouseenter", function (e) {
        $('body').addClass('nav-overlay');
    })
    $('.navigation-header').on("mouseleave", function (e) {
        if( !$(e.toElement).parents().hasClass('info-bar') ) {
            $('.navigation-header').removeClass('navigation-hover');
            setTimeout(() => {
                $('.navigation-header').removeClass('navigation-hover-trans');
            }, 200)
        }
    })
    $('.navigation__item').on("mouseleave", function (e) {
        if( !$(e.toElement).parents().hasClass('navigation__menu') ) {
            $('body').removeClass('nav-overlay');
        }
    })
    $('.navigation__submenu').on("mouseleave", function (e) {
        if( !$(e.toElement).parents().hasClass('navigation__menu') ) {
            $('body').removeClass('nav-overlay');
        }
        if( !$(e.toElement).parents().hasClass('navigation') ) {
            $('.navigation-header').removeClass('navigation-hover');
            setTimeout(() => {
                $('.navigation-header').removeClass('navigation-hover-trans');
            }, 200)
        }
    })
    $('.navigation__menu').on("mouseleave", function (e) {
            $('body').removeClass('nav-overlay');
    })



    //---------------------
    // Toggle class on hover
    //---------------------
    $('.navigation__items > .navigation__item.navigation__items-has-submenu').each(function () {
        $(this).on("mouseenter", function () {
            $(this).addClass('navigation__item-hover');
            setTimeout(() => {
                $('body').addClass('has-sidebar has-sidebar-nav');
            }, 1)
        });
    })
    //hover out main menu item and close dropdown
    $('.navigation__items > .navigation__item').on("mouseleave", function (e) {
        e.stopPropagation();
        // $('.navigation-header').removeClass('navigation-bg');
        $(this).removeClass('navigation__item-hover');
        $('body').removeClass('has-sidebar has-sidebar-nav');
    });


    //---------------------
    // Manipulate menu on scroll
    //---------------------
    function navAnimationClasses() {
        if ($(document).scrollTop() === 0 ) {
            $('.navigation').addClass("navigation-top");
        }
        if ($(document).scrollTop() > fullHeight || $(document).scrollTop() > fullHeight && $('body').hasClass('sidebar-cart-opened')) {
            $('.navigation').addClass("scrolled").addClass("nav_hidden").addClass("scrollUpFixed").removeClass("navigation-top");
            // $('.navigation--relative').css("padding-top", fullHeight - infoHeight);
            $('.navigation-header').addClass('navigation-bg');
        } else {
            $('.navigation').removeClass("scrolled").removeClass('nav_animate');
            $('.navigation-header').removeClass('navigation-bg');
        }
        if ($(document).scrollTop() <= infoHeight || $(document).scrollTop() <= infoHeight && $('body').hasClass('sidebar-cart-opened')) {
            // $('.navigation--relative').css("padding-top", '');
            $('.navigation').addClass("navigation-top").removeClass("scrollUpFixed");
        }
    }


    //---------------------
    // Set sub menu left offset if overflows document
    //---------------------
    function setNavOffset() {
        $('.navigation__items > .navigation__item').each(function() {
            var $this = $(this);
            var $linksWidth = $(this).children('.navigation__submenu').outerWidth();
            var $documentWidth = $(window).outerWidth();
            var $offset = $(this).offset().left;
            var left = ($documentWidth - $offset) - $linksWidth - 15;
            if ($linksWidth > $documentWidth - $offset) {
                $this.children('.navigation__submenu').css('left', left)
            } else {
                $this.children('.navigation__submenu').css('left', '')
            }
        });
    }


    //---------------------
    // On scroll functions
    //---------------------
    let lastScroll = 0;
    $(window).on('scroll',function() {
        var scroll = $(window).scrollTop();
        if(lastScroll - scroll > 0 && scroll > fullHeight) {
            $(".navigation").addClass("scrollUp ").removeClass("nav_hidden").addClass('nav_animate');
        } else {
            $(".navigation").removeClass("scrollUp");
        }
        lastScroll = scroll;

        navAnimationClasses();
    });



    //---------------------
    // On load functions
    //---------------------
    $(window).on('load',function() {
        setNavOffset();
        if ($(document).scrollTop() === 0 ) {
            $('.navigation').addClass("navigation-top");
        }
    });


    //---------------------
    // On resize functions
    //---------------------
    var windowWidth = $(window).width();
    window.addEventListener('resize', () => {
        if ($(window).width() == windowWidth) return;
        windowWidth = $(window).width();
        navAnimationClasses();
        setNavOffset();
    });


})(jQuery);